/** Contact details and links shared by Hub public pages. */

export const LEGAL_ENTITY = "No Name Marketing, LLC";
export const LEGAL_DBA = "ATW.Net";
export const LEGAL_NAME_SHORT = "ATW";

export const SUPPORT_EMAIL = "support@atw.net";
export const SUPPORT_PHONE = "+1 (330) 333-2256";
export const SUPPORT_PHONE_HREF = "tel:+13303332256";
export const SUPPORT_HOURS = "Monday to Friday, 8am to 5pm Eastern time";
export const SUPPORT_RESPONSE = "We reply within 2 business days.";

export const ATW_MAILING_ADDRESS = "13940 Cedar Rd 438, University Heights, OH 44118-3204, USA";
export const ATW_CONTACT_URL = "https://atw.net/contact";
export const ATW_TERMS_URL = "https://atw.net/terms";
export const ATW_PRIVACY_URL = "https://atw.net/privacy-policy";

export const HUB_ORIGIN = "https://hub.atw.net";

export const SLACK_INSTALL_URL = "https://api.hub.atw.net/slack/install";

export const PRIVACY_POLICY_UPDATED = "October 5, 2026";
export const TERMS_UPDATED = "October 2, 2026";
export const SECURITY_PAGE_UPDATED = "October 5, 2026";

/**
 * Slack only allows the Real-time Search API and its MCP server for Marketplace-listed apps, so
 * until approval the public pages say Needs you and Hub AI aren't available yet and explain the
 * history rate limit. Set to true once the listing is approved.
 */
export const SLACK_MARKETPLACE_APPROVED = false;
